import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService, GetTokenSilentlyOptions } from '@auth0/auth0-angular';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { AppConfigService } from '../app-config/app-config.service';
import { Router } from '@angular/router';

export function isAuthError(err: unknown) {
  return (
    err?.toString()?.toLowerCase()?.includes('consent required') ||
    err?.toString()?.toLowerCase()?.includes('login required')
  );
}

export function getAuthToken(
  configService: AppConfigService,
  authService: AuthService,
  router: Router
): Observable<string | unknown> {
  const options: GetTokenSilentlyOptions = {
    authorizationParams: {
      audience:
        configService.config.auth0Config.authorizationParams?.['audience'],
    },
  };

  return authService.getAccessTokenSilently(options).pipe(
    catchError((err) => {
      if (isAuthError(err)) {
        router.navigate(['/logged-out']);
      }
      return of(null);
    })
  );
}

export const refreshTokenInterceptorFn = function (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const configService = inject(AppConfigService);
  const authService = inject(AuthService);
  const router = inject(Router);
  return next(req).pipe(
    catchError((err) => {
      if (isAuthError(err)) {
        return getAuthToken(configService, authService, router).pipe(
          switchMap((token) => {
            const clone = req.clone({
              headers: req.headers.set('Authorization', `Bearer ${token}`),
            });
            return next(clone);
          })
        );
      }
      return throwError(() => err);
    })
  );
};
